// @flow

// let React;
// let ReactDOM;

import React from "react";
import ReactDOM from "react-dom";

import { getClosest, pubsub } from "@utils";

import LoginForm from "@components/organisms/LoginForm";
import ResetPasswordForm from "@components/organisms/ResetPasswordForm";
import ResetPasswordEntryForm from "@components/organisms/ResetPasswordEntryForm";
import RegisterForm from "@components/organisms/RegisterForm";
import PostRegistrationForm from "@components/organisms/PostRegistrationForm";
import ContactForm from "@components/organisms/ContactForm";
import PreferencesForm from "@components/organisms/PreferencesForm";
import PasswordMedicalPortalForm from "@components/organisms/PasswordMedicalPortalForm";
import TermsAndConditionForm from "@components/organisms/TermsAndConditionForm";
import ToolkitOrderForm from "@components/organisms/ToolkitOrderForm";
type PropsType = {
    $element: HTMLElement,
    id: ?string,
};

class ReactForm {
    props: PropsType;
    $element: HTMLElement;

    constructor(props: PropsType) {
        // set props and defaults
        this.props = {
            ...props,
            id: props.$element
                ? props.$element.getAttribute("data-react-form")
                : null,
        };

        // elements
        this.$element = props.$element;

        // fixed forms (used for mapping to dynamic imports)
        this.fixedForms = [
            {
                id: "login",
                importer: this.dynamicImportLoginForm.bind(this),
            },
            {
                id: "reset-password",
                importer: this.dynamicImportResetPasswordForm.bind(this),
            },
            {
                id: "reset-password-entry",
                importer: this.dynamicImportResetPasswordEntryForm.bind(this),
            },
            {
                id: "register",
                importer: this.dynamicImportRegisterForm.bind(this),
            },
            {
                id: "post-registration",
                importer: this.dynamicImportPostRegistrationForm.bind(this),
            },
            {
                id: "contact",
                importer: this.dynamicImportContactForm.bind(this),
            },
            {
                id: "preferences",
                importer: this.dynamicImportPreferencesForm.bind(this),
            },
            {
                id: "password-medical-portal",
                importer: this.dynamicImportPasswordMedicalPortalForm.bind(
                    this
                ),
            },
            {
                id: "terms-and-condition",
                importer: this.dynamicImportTermsAndConditionForm.bind(this),
            },
            {
                id: "toolkit-order-form",
                importer: this.dynamicImportToolkitOrderForm.bind(this),
            },
            {
                id: "toolkit-order-form-public",
                importer: this.dynamicImportToolkitOrderForm.bind(this),
            },
        ];

        // kick off
        this.init();
        // bind events
        this.bindEvents();
    }

    bindEvents() {}

    buildHiddenInputs(inputs: array): any {
        return (
            <>
                {inputs.map((input, index): any => {
                    return (
                        <div
                            key={index}
                            dangerouslySetInnerHTML={{ __html: input }}
                        ></div>
                    );
                })}
            </>
        );
    }

    init() {
        if (this.props.$element) {
            // dynamically import react and react-dom
            // Promise.all([import("react"), import("react-dom")])
            //     .then(module => {
            //         React = module[0].default;
            //         ReactDOM = module[1].default;

            //         this.processForms();
            //     })
            //     .catch(error => {
            //         console.log(error);
            //     });

            this.processForms();
        }
    }

    processForms() {
        // extend any drupal forms data to this form if matched by id
        if (window.drupalForms) {
            for (let drupalForm of window.drupalForms) {
                if (drupalForm && drupalForm.id === this.props.id) {
                    this.props = {
                        ...this.props,
                        ...drupalForm,
                        hiddenInputs: this.buildHiddenInputs([
                            drupalForm.form_build_id,
                            drupalForm.form_id,
                            drupalForm.form_token,
                        ]),
                        captcha: this.buildHiddenInputs([drupalForm.captcha]),
                    };
                }
            }
        }

        let isFixedForm;
        for (let fixedForm of this.fixedForms) {
            if (this.props.id && this.props.id === fixedForm.id) {
                isFixedForm = true;
                fixedForm.importer();

                // check if form is in a lightbox, reinit on lightbox open
                const parentLightbox = getClosest(
                    this.$element,
                    `[data-lightbox]`
                );
                if (parentLightbox) {
                    const parentLightboxId = parentLightbox.getAttribute(
                        "data-lightbox"
                    );
                    if (parentLightboxId) {
                        // subscribe to lightbox open event to load the form
                        pubsub.subscribe(`open-${parentLightboxId}`, () => {
                            fixedForm.importer();
                        });
                    }
                }
            }
        }

        if (!isFixedForm) {
            // Dynamic form builders (TODO)
        }
    }

    dynamicImportLoginForm() {
        // import("@components/organisms/LoginForm").then((module: any) => {
        //     ReactDOM.render(<module.default {...this.props} />, this.$element);
        // });

        ReactDOM.render(<LoginForm {...this.props} />, this.$element);
    }

    dynamicImportResetPasswordForm() {
        // import("@components/organisms/ResetPasswordForm").then((module: any) => {
        //     ReactDOM.render(<module.default {...this.props} />, this.$element);
        // });

        ReactDOM.render(<ResetPasswordForm {...this.props} />, this.$element);
    }

    dynamicImportResetPasswordEntryForm() {
        // import("@components/organisms/ResetPasswordEntryForm").then((module: any) => {
        //     ReactDOM.render(<module.default {...this.props} />, this.$element);
        // });

        ReactDOM.render(
            <ResetPasswordEntryForm {...this.props} />,
            this.$element
        );
    }

    dynamicImportRegisterForm() {
        // import("@components/organisms/RegisterForm").then((module: any) => {
        //     ReactDOM.render(<module.default {...this.props} />, this.$element);
        // });

        ReactDOM.render(<RegisterForm {...this.props} />, this.$element);
    }

    dynamicImportPostRegistrationForm() {
        // import("@components/organisms/PostRegistrationForm").then(
        //     (module: any) => {
        //         ReactDOM.render(
        //             <module.default {...this.props} />,
        //             this.$element
        //         );
        //     }
        // );

        ReactDOM.render(
            <PostRegistrationForm {...this.props} />,
            this.$element
        );
    }

    dynamicImportContactForm() {
        // import("@components/organisms/PostRegistrationForm").then(
        //     (module: any) => {
        //         ReactDOM.render(
        //             <module.default {...this.props} />,
        //             this.$element
        //         );
        //     }
        // );

        ReactDOM.render(<ContactForm {...this.props} />, this.$element);
    }

    dynamicImportPreferencesForm() {
        // import("@components/organisms/PostRegistrationForm").then(
        //     (module: any) => {
        //         ReactDOM.render(
        //             <module.default {...this.props} />,
        //             this.$element
        //         );
        //     }
        // );

        ReactDOM.render(<PreferencesForm {...this.props} />, this.$element);
    }

    dynamicImportPasswordMedicalPortalForm() {
        // import("@components/organisms/PasswordMedicalPortalForm").then(
        //     (module: any) => {
        //         ReactDOM.render(
        //             <module.default {...this.props} />,
        //             this.$element
        //         );
        //     }
        // );

        ReactDOM.render(
            <PasswordMedicalPortalForm {...this.props} />,
            this.$element
        );
    }

    dynamicImportTermsAndConditionForm() {
        // import("@components/organisms/TermsAndConditionForm").then(
        //     (module: any) => {
        //         ReactDOM.render(
        //             <module.default {...this.props} />,
        //             this.$element
        //         );
        //     }
        // );

        ReactDOM.render(
            <TermsAndConditionForm {...this.props} />,
            this.$element
        );
    }

    dynamicImportToolkitOrderForm() {
        // import("@components/organisms/ToolkitOrderForm").then(
        //     (module: any) => {
        //         ReactDOM.render(
        //             <module.default {...this.props} />,
        //             this.$element
        //         );
        //     }
        // );
        console.log("props", this.props);
        if (this.props.id === "toolkit-order-form-public") {
            ReactDOM.render(
                <ToolkitOrderForm public={true} {...this.props} />,
                this.$element
            );
        } else {
            ReactDOM.render(
                <ToolkitOrderForm {...this.props} />,
                this.$element
            );
        }
    }
}

export default ReactForm;
